import axios from "axios";
import config from "../config";

// const API_URL = process.env.BACKEND_URL + 'api';
const API_URL = config.WS_BASE_URL;
// const API_URL = ''

const axiosApi = axios.create({
  // baseURL: API_URL,
  baseURL: API_URL,
  validateStatus: function (status) {
    return status >= 200 && status < 600;
  },
});

axios.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

const getToken = () => {
  return localStorage.getItem("sessionToken") ?? sessionStorage.getItem("sessionToken");
};
// for data fetching
export async function get(url, queryValue, config = {}) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    getToken() ?? ""
  }`;
  return await axiosApi
    .get(url, { ...config, params: queryValue })
    .then((response) => response.data);
}

const addAuthToken = () => {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    getToken() ?? ""
  }`;
};

export async function getRequest(...args) {
  addAuthToken();
  return axiosApi.get(...args);
}

export async function postRequest(...args) {
  addAuthToken();
  return axiosApi.post(...args);
}

export async function putRequest(...args) {
  addAuthToken();
  return axiosApi.put(...args);
}

export async function deleteRequest(...args) {
  addAuthToken();
  return axiosApi.delete(...args);
}

// for data posting
export async function post(url, data, config = {}) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    getToken() ?? ""
  }`;
 return await axiosApi.post(url, data, { ...config });
}

// for data updating
export async function put(url, data, queryValue, config = {}) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
    getToken() ?? ""
  }`;
  return await axiosApi
    .put(url, { ...data }, { ...config, params: queryValue })
    .then((response) => response.data);
}

// for data deleting
export async function del(url, data, config = {}) {
  axiosApi.defaults.headers.common["Authorization"] = `Bearer ${
   getToken() ?? ""
  }`;
  return await axiosApi
    .delete(url, { ...config, params: data })
    .then((response) => response.data);
}
